import styled from 'styled-components'

export const FallBackWrapper = styled.div`
  width: 100vw;
  height: calc(var(--vh, 1svh) * 100);
  background: ${({ theme }) => theme?.colors?.bodyBackground || '#fff'};
  position: fixed;
  top: 0;
  left: 0;
`
